import React from 'react';
import { Download, Loader2 } from 'lucide-react';

const timeRanges = ["Last 30 Days", "Last 90 Days", "This Year", "All Time"];

const AnalyticsHeader = ({ timeRange, setTimeRange, handleExport, isExporting }) => {
    return (
        <header className="analytics-header-container">
            <div className="header-left">
                <h1>Performance Analytics</h1>
                <p>Track win rates, pipeline health, and team performance</p>
            </div>
            <div className="header-right">
                <div className="time-filter-pill">
                    {timeRanges.map((t) => (
                        <button
                            key={t}
                            onClick={() => setTimeRange(t)}
                            className={`filter-button ${timeRange === t ? "active" : ""}`}
                        >
                            {t}
                        </button>
                    ))}
                </div>
                <button 
                    className="export-button"
                    onClick={handleExport}
                    disabled={isExporting}
                    style={{ opacity: isExporting ? 0.7 : 1, cursor: isExporting ? 'not-allowed' : 'pointer' }}
                >
                    {isExporting ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />} 
                    {isExporting ? "Exporting..." : "Export Report"}
                </button>
            </div>
        </header>
    );
};

export default AnalyticsHeader;
